import {GetChunkFn} from '../types/GetChunkFn';

// Web implementation of the `GetChunkFn` contract: reads a byte range of a (blob) URI via a ranged
// `fetch` for chunked multipart upload. The native counterpart (`getMobileChunk`) lives in CarAudit.
export const getWebChunk: GetChunkFn = (params) => {
  const start = params.index * params.chunkSize;
  const end = Math.min((params.index + 1) * params.chunkSize, params.fileSize) - 1;

  return fetch(params.uri, {headers: {Range: `bytes=${start}-${end}`}}).then((response) =>
    response.arrayBuffer()
  );
};
